import CanalCobroForm from './CanalCobroForm'
export {CanalCobroForm}
export default CanalCobroForm
